import DrawerButton from "components/form/DrawerButton";
import Error from "components/form/Error";
import LabelArea from "components/form/LabelArea";
import Title from "components/form/Title";
import useMinDuration from "hooks/useMinDurationSubmit";
import React from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { Input } from "@windmill/react-ui";
import Uploader from "components/image-uploader/Uploader";
import { FiX } from "react-icons/fi";
import { useState } from "react";
const MinDurationDrawer = ({ id }) => {

    const {
        register,
        handleSubmit,
        onSubmit,
        errors,
    } = useMinDuration(id);




    return (
        <>
            <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
                {id ? (
                    <Title title={"Edit Min Duration"} description={""} />
                ) : (
                    <Title title={"Add News"} description={""} />
                )}
            </div>

            <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">

                <form onSubmit={handleSubmit(onSubmit)}>

                    <div className="px-6 pt-8 flex-grow scrollbar-hide w-full max-h-full pb-40">
                        <div className="gap-3 mb-6">

                            <div
                                className="grid grid-cols-6 gap-3 mb-6"
                                style={{ display: "block", justifyContent: "space-between" }}
                            >

                                <div style={{ width: "100%" }}>
                                    <LabelArea label={"Name"} />
                                    <Input
                                        {...register("name")}
                                        className="border h-10 text-sm focus:outline-none block bg-white-100 dark:bg-white border-transparent focus:bg-white mb-2"
                                        placeholder="Name"
                                        disabled
                                    />
                                    {errors?.name && (
                                        <Error errorName={errors.name.message} />
                                    )}
                                </div>


                                <div style={{ width: "100%" }}>
                                    <LabelArea label={"Min Booking Minutes"} />
                                    <Input
                                        {...register("min_booking_minutes")}
                                        className="border h-10 text-sm focus:outline-none block bg-white-100 dark:bg-white border-transparent focus:bg-white mb-2"
                                        placeholder="Min Booking Minutes"
                                    />
                                    {errors?.min_booking_minutes && (
                                        <Error errorName={errors.min_booking_minutes.message} />
                                    )}
                                </div>
                            </div>

                        </div>
                    </div>

                    <DrawerButton id={id} title={id ? "Update" : "Submit"} />
                </form>
            </Scrollbars>
        </>
    );
};

export default MinDurationDrawer;
